import React from 'react';

function IframeExample(): JSX.Element {
  return (
    <div className="example-iframe" id="iframe-wehi">
      <div>
        <p>
          Imagine that this around the experience its your website
        </p>
      </div>
      <iframe
        title="WEHI Experience"
        src="https://wehi.spacesinteractive.dev/"
        allow="fullscreen"
      />
    </div>
  );
}

export default IframeExample;
